/**
 * Valida si el valor es un array.
 * @param {*} value - Valor a validar.
 * @returns {Array} - Si es array, devuelve el mismo array; si no, devuelve [].
 */
export const ensureArray = (value) => {
    return Array.isArray(value) ? value : [];
};


/**
 * Valida si un valor es JSON válido (objeto o string JSON).
 * Si es válido retorna el objeto JSON, si no retorna un objeto vacío {}.
 * @param {*} value - Valor a validar (string o objeto).
 * @returns {object} - El objeto JSON válido o {}.
 */
export const ensureJsonObject = (value) => {
    if (typeof value === 'object' && value !== null) {
        return value;
    }

    if (typeof value === 'string') {
        try {
            const parsed = JSON.parse(value);
            if (typeof parsed === 'object' && parsed !== null) {
                return parsed;
            }
        } catch {
        }
    }
    return {};
};

/**
 * Valida si los parámetros son suficientes para realizar la consulta a la DIAN.
 * @param {string|number} type_identification 
 * @param {string|number} identification
 * @returns {boolean}
 */
export const isValidDianQuery = (type_identification, identification) => {
    return Boolean(
        type_identification &&
        identification &&
        String(identification).trim().length >= 5
    );
};

/**
 * Parsea y normaliza la respuesta del servicio adquirente de la DIAN
 * @param {*} rawData
 * @returns {{isSuccess: boolean, statusCode: string, businessName: string|null, email: string|null}}
 */
export const parseDianResponse = (rawData) => {
    if (typeof rawData === 'string' || rawData instanceof Document) {
        return { isSuccess: false, statusCode: 'HTML', businessName: null, email: null };
    }
    const statusCode = String(rawData?.StatusCode ?? rawData?.statusCode ?? '');
    return {
        isSuccess: statusCode === '200',
        statusCode,
        businessName: rawData?.ReceiverName ?? null,
        email:        rawData?.ReceiverEmail ?? null,
    };
};